import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { Pl9data } from '../../models/pl9data';
import { NavController } from '@ionic/angular';
import { BarcodeScannerOptions, BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-posm-pl9-search',
  templateUrl: './posm-pl9-search.page.html',
  styleUrls: ['./posm-pl9-search.page.scss'],
})
export class PosmPl9SearchPage implements OnInit {

  data = new Data();
  myId: any;
  user: any;
  model: Pl9data[];
  dataSource: MatTableDataSource<Pl9data>;

  displayedColumns: string[] = ['position', 'date', 'pl9', 'quantity','price'];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  searching = false;
  scannedData: any;
  barcodeScannerOptions: BarcodeScannerOptions;
  active = false;
  verify = false;
  error = false;
  ic = '';
  icx = '';
  trans: any;

  constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute, private barcodeScanner: BarcodeScanner, private navCtrl: NavController, public dialog: MatDialog, private spinner: NgxSpinnerService) {

  }

  ngOnInit() {

    /*const ELEMENT_DATA: PeriodicElement[] = [
      {position: 1, name: 'Abc', weight: 1.0079, symbol: 'H'},
      {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
      {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
      {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
      {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
      {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
      {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
    ];*/

    

    /*this.apiService.postData(this.data).subscribe((response) => {
      this.product = response.data;
    });*/
  }

  getRecord(row) {
    console.log(row);
    window.open("http://dexmart.dexasia.com.my/form/pl9.php?id=" + row.pl9, "_blank");
  }

  getCust() {
    this.searching = false;


    this.data =  {
      id: 4,
      name: 'posGetPL9',
      content: {
        ic: this.ic,
        icx: this.icx
      }
    };

    console.log(this.data);

    this.apiService.postData(this.data).subscribe((response) => {

      this.searching = true;

      this.model = response.data;

      console.log(this.model);

      this.dataSource = new MatTableDataSource(this.model);


    });
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(DialogThirteenPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  getLimit() {
    if (this.myId === '126') {
      return 12;
    } else {
      return 14;
    }
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogThirteenPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
